import { render, staticRenderFns } from "./PackStoreItem.vue?vue&type=template&id=74893854&scoped=true"
import script from "./PackStoreItem.vue?vue&type=script&lang=js"
export * from "./PackStoreItem.vue?vue&type=script&lang=js"
import style0 from "./PackStoreItem.vue?vue&type=style&index=0&id=74893854&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74893854",
  null
  
)

export default component.exports